import { ColDef } from 'ag-grid-community';
import { t } from 'i18next';

import { getPercentage } from 'core/utils';
import { DiscountApplyToTypes } from 'corporate/enums';
import { CriteriaCell } from 'pricing/components';
import { IPricingProfile } from 'pricing/types';
import { Color } from 'theme/enums';

import { ActionsCell } from './cells';

const applyToTranslationKeys: Record<string, string> = {
  [DiscountApplyToTypes.STD_COST]: 'labelStandardCost',
  [DiscountApplyToTypes.LIST_PRICE]: 'labelListPrice',
};

interface IColumnDefParams {
  pricingProfile: IPricingProfile;
  isEditable?: boolean;
}

export const getColumnDef = ({ pricingProfile, isEditable = true }: IColumnDefParams): ColDef[] => [
  {
    colId: 'actions',
    width: 80,
    maxWidth: 80,
    sortable: false,
    resizable: false,
    cellRenderer: ActionsCell,
    cellRendererParams: {
      pricingProfile,
      isEditable,
    },
    suppressColumnsToolPanel: true,
    pinned: 'left',
    lockPinned: true,
  },
  {
    colId: 'manufacturerName',
    headerName: t('headerManufacturer'),
    field: 'manufacturerName',
    filter: 'agTextColumnFilter',
    valueFormatter: ({ value }) => value || t('labelAll'),
    width: 200,
  },
  {
    colId: 'path',
    headerName: t('headerCategory'),
    field: 'categoryPath',
    filter: 'agTextColumnFilter',
    valueFormatter: ({ value }) => value || t('labelAll'),
    width: 300,
  },
  {
    colId: 'partFieldCriteria',
    headerName: t('headerPartSpecificationCriteria'),
    field: 'partFieldCriteria',
    sortable: false,
    cellRenderer: CriteriaCell,
    cellRendererParams: {
      criteriaFieldName: 'partFieldName',
    },
    minWidth: 200,
    flex: 1,
  },
  {
    colId: 'corporatePartFieldCriteria',
    headerName: t('headerCompanyPartSpecificationCriteria'),
    field: 'corporatePartFieldCriteria',
    sortable: false,
    cellRenderer: CriteriaCell,
    cellRendererParams: {
      criteriaFieldName: 'corporatePartFieldName',
    },
    minWidth: 200,
    flex: 1,
  },
  {
    colId: 'applyTo',
    headerName: t('headerApplyDiscountTo'),
    field: 'applyTo',
    filter: 'agSetColumnFilter',
    valueFormatter: ({ value }) => t(applyToTranslationKeys[value]),
    filterParams: {
      values: [DiscountApplyToTypes.STD_COST, DiscountApplyToTypes.LIST_PRICE],
      valueFormatter: ({ value }) => t(applyToTranslationKeys[value]),
    },
    width: 200,
  },
  {
    colId: 'discount',
    headerName: t('headerValue'),
    field: 'discount',
    filter: 'agNumberColumnFilter',
    valueFormatter: ({ value }) => getPercentage(-value, { isRawPercentage: true }),
    cellRendererParams: {
      color: Color.DANGER,
    },
    width: 150,
  },
];
